import { RedoProduct } from "@redotech/redo-common-model/redo-product";
import * as z from "zod";

/**
 * Gen II `Integration` kinds queryable for connected status (input whitelist);
 * extend only when a registry entry adopts a `gen2Kind` status source.
 */
export const gen2StatusKinds = [
  "Adyen",
  "AmazonSellingPartners",
  "Attentive",
  "Bigcommerce",
  "CanadaPostCarrierAccount",
  "ChitChatsCarrierAccount",
  "Cin7Core",
  "CommerceCloud",
  "DhlEcommerceDirectCarrierAccount",
  "Easypost",
  "Ebay",
  "Facebook",
  "Faire",
  "FedExCarrierAccount",
  "GoogleAds",
  "GoogleMerchantCenter",
  "Gorgias",
  "Growave",
  "HappyReturns",
  "Instagram",
  "Kustomer",
  "LandmarkGlobal",
  "Liquidonate",
  "MetaAds",
  "OkendoMarketing",
  "Optty",
  "OrdersApi",
  "ParentEasypost",
  "PayPal",
  "Postscript",
  "Recharge",
  "SendcloudCarrierAccount",
  "ShipStationApi",
  "Skio",
  "StallionExpressCarrierAccount",
  "StayAi",
  "TiktokAds",
  "UniUniCarrierAccount",
  "UnifiedTemu",
  "UnifiedTiktok",
  "UpsGhostAccountIntegration",
  "UspsCarrierAccount",
  "Walmart",
  "Wayfair",
  "WooCommerce",
] as const;

export type Gen2StatusKind = (typeof gen2StatusKinds)[number];

/**
 * RedoProduct subset a Gen II doc can report per-product activation for;
 * only kinds whose schema carries real per-product flags ever populate this.
 */
export const gen2ActiveProducts = [
  RedoProduct.MARKETING,
  RedoProduct.OMS,
  RedoProduct.RETURNS,
  RedoProduct.SUPPORT,
] as const;

export type Gen2ActiveProduct = (typeof gen2ActiveProducts)[number];

const integrationStatusSchema = z.object({
  isConnected: z.boolean(),
  activeProducts: z.array(z.enum(gen2ActiveProducts)).optional(),
});

export const getGen2IntegrationStatuses = {
  name: "getGen2IntegrationStatuses" as const,
  input: z.object({ kinds: z.array(z.enum(gen2StatusKinds)) }),
  output: z.partialRecord(z.enum(gen2StatusKinds), integrationStatusSchema),
};
